import Vue from "vue";
export const visibility = Vue.observable({ status: true });